import React, { useRef } from "react";
import Loader from "../../../components/Loader";
import t from "../../../helpers/t";
import * as useChartsData from "../../../helpers/useChartsData";

import StatisticsConfig from "./ClientStatisticsConfig.json";
import BookingChart from "../../../components/Chart/BookingChart";

/**
 * Chart configuration (type, data channel, title) for each client is stored in:
 * - `src/js/react/pages/dashboard/components/ClientStatisticsConfig.json`
 * For chart object definition, see:
 * - `src/js/react/pages/dashboard/components/StatisticsLite.js`
 */

export default (props) => {
  // Read configuration from ClientStatisticsConfig.json with client_id as key.
  // Else, fall-back to "" key if exists.
  // Else, return empty configuration.
  // props.client_id === Biscuit.get("user.client_id")
  const config = StatisticsConfig[props.client_id] || StatisticsConfig[""] || { charts: null }; // default
  const chartConfig = config.charts;

  // Possible channels
  // To add new channels (as a React Hook), includes it below
  const fetcher = {
    Summary: useChartsData.useSummary(),
    SummaryPerMonth: useChartsData.useSummaryPerMonth(),
    CountOfBookingsPerMembership: useChartsData.useCountOfBookingsPerMembership(),
    CountOfUsersPerMembership: useChartsData.useCountOfUsersPerMembership(),
  };

  if (chartConfig) {
    const charts = useRef();
    if (!charts.current) {
      const now = new Date();
      // Query once only
      Object.values(fetcher).forEach(([_, __, query]) => query({ from: now, to: now }));
      charts.current = true;

      console.info("Statistic lite generated");
    }
    const chartComps = chartConfig.map(({ title, key, channel, type, isStacked }, idx) => {
      const data = key !== undefined ? fetcher[channel][0][key] : fetcher[channel][0];
      return (
        <div className="dashboard-chart" key={`statistics-lite-${idx}`} style={{ height: "240px" }}>
          {fetcher[channel][1] ? (
            <>
              <p className="chart-title">{t(title)}</p>
              <BookingChart data={data} type={type} isStacked={isStacked} />
            </>
          ) : (
            <Loader mediumWidth={3} smallWidth={3} subLoaders={1} />
          )}
        </div>
      );
    });
    return (
      <div className="dashboard-main-content">
        <span className="dashboard-content-charts">{chartComps}</span>
      </div>
    );
  }
  return <></>;
};
